import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Add dark class to HTML element on initial render
document.documentElement.classList.add("dark");

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
